import { jsx as _jsx } from "react/jsx-runtime";
import { NestedHidden } from "@air/next-icons";
import { memo } from "react";
import { SearchToken } from "~/components/SearchBar/SearchToken";
import { SEARCH_BOARD_TOKEN } from "~/constants/testIDs";
import { useIsFlattenedView } from "~/hooks/search/useIsFlattenedView";
export const FlattenedBoardSearchToken = /*#__PURE__*/ memo((param)=>{
    let { boardName } = param;
    const { setIsFlattenedView } = useIsFlattenedView();
    return /*#__PURE__*/ _jsx(SearchToken, {
        testId: SEARCH_BOARD_TOKEN,
        tooltipText: "".concat(boardName, " (expanded)"),
        icon: /*#__PURE__*/ _jsx(NestedHidden, {
            className: "mr-1 size-3 shrink-0 text-blue-11"
        }),
        tokenName: boardName,
        color: "blue",
        onCloseClick: ()=>{
            setIsFlattenedView(false);
        }
    });
});
FlattenedBoardSearchToken.displayName = "FlattenedBoardSearchToken";
